export const NEO_IMAGE_LIST_PRESET = [
  {
    displayedName: 'Ванная комната для эстетов',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'vannaya-komnata-dlya-estetov',
    style: 'neo',
  },
  {
    displayedName: 'Естественная простота мраморной ванной',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'estestvennaya-prostota-mramornoy-vannoy',
    style: 'neo',
  },
  {
    displayedName: 'Роскошная ванная комната в тёмных оттенках',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'roskoshnaya-vannaya-komnata-v-temnyh-ottenkah',
    style: 'neo',
  },
  {
    displayedName: 'Минеральные оттенки роскошной ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'mineralnye-ottenki-roskoshnoy-vannoy-komnaty',
    style: 'neo',
  },
];
